import { Component, input } from '@angular/core';
import { UmssIconComponent } from '../icon/icon.component';

export type ComparisonSortDirection = 'asc' | 'desc' | null;

/**
 * Presentational arrow for a sortable `[comparison-label]`.
 * Hidden until the parent label is hovered; always visible while sorted.
 * The consumer owns the state and cycles it on label click.
 */
@Component({
  selector: 'umss-comparison-sort-arrow',
  standalone: true,
  imports: [UmssIconComponent],
  template: `
    <umss-icon
      [name]="direction() === 'asc' ? 'phosphorArrowRight' : 'phosphorArrowLeft'"
      size="14px"
    />
  `,
  host: {
    class: 'comparison-sort-arrow',
    '[class.comparison-sort-arrow--active]': '!!direction()',
    '[class.comparison-sort-arrow--asc]': "direction() === 'asc'"
  }
})
export class UmssComparisonSortArrowComponent {
  direction = input<ComparisonSortDirection>(null);
}
